import Head from 'next/head';
import getFlagValue, { FLAG_ENUM } from '../../../helpers/utils/getFlagValue';
import Script from 'next/script';

export default function EmarsysHead() {
  if (getFlagValue(FLAG_ENUM.EMARSYS)) {
    return (
      <>
        <Head>
          {getFlagValue(FLAG_ENUM.EMARSYS_WEB_PUSH) && (
            <link rel="manifest" href="/manifest.json" />
          )}

          {/* Emarsys Web Push script */}
          {getFlagValue(FLAG_ENUM.EMARSYS_WEB_PUSH) && (
            <script
              type="text/javascript"
              src="https://client-version.cf.emarsys.net/web-emarsys-sdk-v4/latest/web-emarsys-sdk.js"
              async
            ></script>
          )}
          {getFlagValue(FLAG_ENUM.EMARSYS_WEB_PUSH) && (
            <script
              type="text/javascript"
              dangerouslySetInnerHTML={{
                __html: `
                            var WebEmarsysSdk = WebEmarsysSdk || []
                            WebEmarsysSdk.push(['init', {
                              applicationCode: '${process.env.NEXT_PUBLIC_EMARSYS_APP_CODE}',
                              enableMacSafariVapid: true,
                              safariWebsitePushID: '${process.env.NEXT_PUBLIC_EMARSYS_WEB_PUSH_ID}',
                              defaultNotificationTitle: '${process.env.NEXT_PUBLIC_EMARSYS_DEFAULT_TITLE}',
                              defaultNotificationIcon: '${process.env.NEXT_PUBLIC_EMARSYS_DEFAULT_ICON}',
                              autoSubscribe: ${process.env.NEXT_PUBLIC_EMARSYS_AUTO_SUBSCRIBE || false},
                              serviceWorker: {
                                url: '${process.env.NEXT_PUBLIC_EMARSYS_SW_URL}',
                                applicationServerPublicKey: '${process.env.NEXT_PUBLIC_EMARSYS_SW_PUBLIC_KEY}'
                                }
                            }])`,
              }}
            />
          )}
        </Head>

        {/* CDP script */}
        {getFlagValue(FLAG_ENUM.EMARSYS_CDP) && (
          <Script
            defer
            src="https://cdns.cdp.gigya.com/websdk.js"
            onLoad={() => {
              (window as any).CDP = null;
              gigya.cdp
                .init({
                  apiDomain: `${process.env.NEXT_PUBLIC_CDP_API_DOMAIN}`,
                  bUnitId: `${process.env.NEXT_PUBLIC_CDP_UNIT_ID}`,
                  appId: `${process.env.NEXT_PUBLIC_CDP_APP_ID}`,
                })
                .then(function (sdk) {
                  return ((window as any).CDP = sdk);
                });
            }}
          ></Script>
        )}

        {/* Emarsys Web Channel script */}
        <Script
          defer
          strategy="afterInteractive"
          type="text/javascript"
          dangerouslySetInnerHTML={{
            __html: `
                        var ScarabQueue = ScarabQueue || [];
                        (function(id) {
                          if (document.getElementById(id)) return;
                          var js = document.createElement('script'); js.id = id;
                          js.src = '//cdn.scarabresearch.com/js/${process.env.NEXT_PUBLIC_EMARSYS_MERCANT_ID}/scarab-v2.js';
                          var fs = document.getElementsByTagName('script')[0];
                          fs.parentNode.insertBefore(js, fs);
                        })('scarab-js-api');
                      `,
          }}
        />
      </>
    );
  }
  return null;
}
